module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-ExtraBold-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-ExtraBold-webfont.eot
// module id = 377
// module chunks = 0